<ng-template #template>
  <div class="modal-header">
    @if (options().titleText) {
    <h2 [id]="'modal-title-' + uuid" class="modal-title">
      @if (options().icon) {
      <fa-icon [icon]="options().icon" class="{{ options().iconClass }} " />
      }{{ options().titleText }}
    </h2>
    }
    <button
      type="button"
      class="close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-content />
  </div>

  @if (options().confirmText || options().rejectText) {
  <div class="modal-footer">
    @if (options().rejectText) {
    <button type="button" class="btn btn-secondary" (click)="hide()" data-testing-id="reject">
      {{ options().rejectText }}
    </button>
    } @if (options().confirmText) {
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="options().confirmDisabled"
      (click)="confirm()"
      data-testing-id="confirm"
    >
      {{ options().confirmText }}
    </button>
    }
  </div>
  }
</ng-template>
